const daysLeft = (plannedCompletionDate, calendar) => {
  const currentDate = new Date();
  const differenceInTime =
    plannedCompletionDate.getTime() - currentDate.getTime();
  const differenceInDays = Math.round(differenceInTime / (1000 * 3600 * 24));
  if (calendar) return differenceInDays > 0 ? differenceInDays : 0;
  return differenceInDays;
};

export default daysLeft;
